// extracted by mini-css-extract-plugin
export var icon = "_9d-3";
export var subtitle = "_9d-2";
export var title = "_9d-1";
export var value = "_9d-0";